import { httpStatus } from '@/core/constants/httpStatus.ts'
import { HttpStatusCode } from '@/core/types/HttpStatus.ts'
import {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig
} from 'axios'
import {
  getStoredTokens,
  refreshTokens,
  removeStoredTokens,
  storeTokens
} from '../utils/security.ts'
import { goToHomePage, goToLoginPage } from '@/core/utils/goToPages.ts'

export const onFulfilledRequestInterceptor = (
  config: InternalAxiosRequestConfig<unknown>
) => {
  const tokens = getStoredTokens()
  if (tokens) {
    config.headers.Authorization = `Bearer ${tokens.token}`
  }
  return config
}

export const onRejectedRequestInterceptor = (error: unknown) => {
  void Promise.reject(error)
}

export const onFulfilledResponseInterceptor = (
  response: AxiosResponse<unknown, unknown>
) => {
  return response
}

export const onRejectedResponseInterceptor = (
  error: AxiosError,
  axiosInstance: AxiosInstance
) => {
  const errorStatus: HttpStatusCode = error?.response?.status as HttpStatusCode
  switch (errorStatus) {
    case httpStatus.NOT_AUTHORIZED:
      return retryAuthorization(error, axiosInstance)
    case httpStatus.FORBIDDEN:
      goToHomePage()
      break
  }
  return Promise.reject(error)
}

const retryAuthorization = async (
  error: AxiosError,
  axiosInstance: AxiosInstance
) => {
  try {
    const tokens = getStoredTokens()
    if (tokens && error.config) {
      const newTokens = await refreshTokens(tokens.refresh_token)
      storeTokens({ ...tokens, token: newTokens.token })
      error.config.headers.Authorization = `Bearer ${newTokens.token}`
      return axiosInstance(error.config)
    } else {
      goToLoginPage()
    }
  } catch {
    removeStoredTokens()
    goToLoginPage()
  }
}
